import { useEffect, useState } from 'react'
import styled from 'styled-components'
import { ActiveProps } from '../Layout/CommonStyle'
import { useNavigate } from 'react-router'

interface Props {
  url: string
  currentPage: number
  setCurrentPage: (currentPage: number) => void
  totalPage: number
  maxDisplayedPage: number
}

function Pagination({
  url,
  currentPage,
  setCurrentPage,
  totalPage,
  maxDisplayedPage,
}: Props) {
  const [pages, setPages] = useState<number[]>([])
  const [prevPage, setPrevPage] = useState<number>(-1)
  const [nextPage, setNextPage] = useState<number>(-1)
  const navigate = useNavigate()

  useEffect(() => {
    const { startPage, endPage, hasPrevPage, hasNextPage } =
      calculatePagination(currentPage, totalPage, maxDisplayedPage)

    const maxPage = Math.min(endPage, totalPage)
    setPages(
      Array.from(
        { length: maxPage - startPage + 1 },
        (_, index) => startPage + index
      )
    )

    setPrevPage(hasPrevPage ? startPage - 1 : -1)
    setNextPage(hasNextPage ? endPage + 1 : -1)
  }, [currentPage, totalPage, maxDisplayedPage])

  const calculatePagination = (
    currentPage: number,
    totalPages: number,
    maxPagesDisplayed: number
  ) => {
    let startPage = 0
    let endPage = 10
    let hasPrevPage = false
    let hasNextPage = false

    console.log('calculatePagination')
    if (currentPage === 0) {
      startPage = 0
    } else {
      startPage =
        Math.floor(currentPage / maxPagesDisplayed) * maxPagesDisplayed
    }
    hasPrevPage = startPage > 0

    endPage = startPage + maxPagesDisplayed - 1
    console.log(`endpage = ${endPage}`)

    if (endPage >= totalPages) {
      endPage = totalPages - 1
      console.log(`endpage = totalPages - 1(${endPage})`)
    }
    hasNextPage = endPage < totalPages - 1

    console.log(`startPage: ${startPage}, endPage: ${endPage}`)
    return { startPage, endPage, hasPrevPage, hasNextPage }
  }

  const navigatePage = (page: number) => {
    setCurrentPage(page)
    navigate(`${url}/${page}`)
  }

  return (
    <Container>
      {prevPage !== -1 && (
        <Page onClick={() => navigatePage(prevPage)} active={false}>
          {'<'}
        </Page>
      )}
      {pages.map((page) => (
        <Page
          key={page}
          onClick={() => navigatePage(page)}
          active={page === currentPage}
        >
          {page + 1}
        </Page>
      ))}
      {nextPage !== -1 && (
        <Page onClick={() => navigatePage(nextPage)} active={false}>
          {'>'}
        </Page>
      )}
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin: 20px 0;
  column-gap: 2px;
`
const Page = styled.div`
  width: 40px;
  padding: 10px 0;
  text-align: center;
  background-color: ${(props: ActiveProps) =>
    props.active ? 'tomato' : 'white'};
  color: ${(props: ActiveProps) => (props.active ? 'white' : 'black')};
  border: 1px solid #aaa;
  cursor: pointer;
`
export default Pagination
